import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import CartList from "../component/common/CartList";
import { addToCart, increment, decrement } from "../redux/cart/cartSlice";
import LoadingForm from "../component/others/LoadingForm";

function BoxDetailGift() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const APIURL = process.env.REACT_APP_API_URL;

  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedNote, setSelectedNote] = useState("");
  const [activeImages, setActiveImages] = useState([]);
  const [cardListActive, setCardListActive] = useState(false);




  const cartItems = useSelector((state) => state.cart.items);


  const cartItem = product
  ? cartItems.find((i) => i._id === product._id)
  : null;



 
  const reorderImagesByNote = (images = [], noteId) => {
    if (!Array.isArray(images)) return [];

    const matched = [];
    const rest = [];

    images.forEach((img) => {
      if (img?.tags?.includes(noteId)) {
        matched.push(img);
      } else {
        rest.push(img);
      }
    });

    return [...matched, ...rest];
  };










useEffect(() => {
  const getProduct = async () => {
    try {
      const res = await fetch(`${APIURL}/api/service/products/${id}`);
      const data = await res.json();

      setProduct(data);

      if (data?.images?.length) {
        setSelectedNote(""); 
        setActiveImages(data.images);
        setSelectedImage(data.images[0]?.url || "");
      }
    } catch (err) {
      console.log(err);
    }
  };

  getProduct();
}, [id, APIURL]);



  if (!product) return <LoadingForm/>



const handleAddToCart = () => {
  if (!selectedNote) return;

  dispatch(
    addToCart({
      _id: product._id,
      name: product.fullName,
      price: product.price,
      image: selectedImage,
      note: selectedNote, // metadata only
    })
  );

  setCardListActive(true);
};



  return (
    <div className="box-detail-container">
      {/* IMAGE SECTION */}
      <div className="images-section">
        <div className="thumbnail-column">
          {activeImages.map((img, i) => (
            <img
              key={i}
              src={img.url}
              className={`thumbnail ${
                selectedImage === img.url ? "selected" : ""
              }`}
              onClick={() => setSelectedImage(img.url)}
              alt=""
            />
          ))}
        </div>

        <div className="box-details-main-image-container">
          {selectedImage && (
            <img
              src={selectedImage}
              className="main-image"
              alt=""
            />
          )}
        </div>
      </div>

      {/* DETAILS */}
      <div className="details-section">
        <h2>{product.fullName}</h2>

        <p className="box-details-page-price-section">
          <span className="original-price">
            Rs. {product.mainPrice}.00
          </span>
          <span className="discounted-price">
            Rs. {product.price}.00
          </span>
        </p>

        {/* NOTES */}
        <p className="box-details-select-notes-text">
         Choose your note
        </p>

        <div className="box-details-select-notes-input">
          <select
            value={selectedNote}
            onChange={(e) => {
              const noteId = e.target.value;
              setSelectedNote(noteId);

              const ordered = reorderImagesByNote(
                product.images || [],
                noteId
              );

              setActiveImages(ordered);
              setSelectedImage(ordered[0]?.url || "");
            }}
          >
            <option value="" >Please Select a Variant</option>

            {product.variants?.notes?.map((note) => (
              <option key={note.id} value={note.id}>
                {note.label}
              </option>
            ))}
          </select>
        </div>

        {/* QUANTITY */}
        <p className="box-details-incriment-quantity-text-heading">
          Quantity
        </p>

        <div className="box-details-incriment-quantity-btn-container">
          <div
            onClick={() => {
              if (cartItem)
                dispatch(decrement({ _id: product._id }));
            }}
          >
            <i className="fa-solid fa-minus"></i>
          </div>

          <div>{cartItem ? cartItem.qty : 1}</div>

          <div
            onClick={() => {

            if (!selectedNote) return;

              if (cartItem) {
                dispatch(
                  increment({ _id: product._id, note: selectedNote })
                );
              } else {
                handleAddToCart();
              }




            }}
          >
            <i className="fa-solid fa-plus"></i>
          </div>
        </div>




{

  selectedNote !== "" ?(
    <div className="box-details-add-to-cart-btn">
          <button onClick={handleAddToCart}>
            ADD TO CART
          </button>
        </div>
  ): (

     <div className="box-details-add-to-cart-btn-disabled">
          <button >
            ADD TO CART
          </button>
        </div>
  )
}



<div className="box-details-pages-offer-sm-test-heading">
<p>  <i class="fa-solid fa-tag"></i> Rs. 50 OFF on Prepaid Orders</p>
<p> <i class="fa-solid fa-truck"></i> FREE Shipping, COD Available</p>
</div>





{/* Manage checkout features from here ::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

      </div>
      <CartList
        active={cardListActive}
        setActive={setCardListActive}
      />
    </div>
  );
}

export default BoxDetailGift;
